import React from "react";
import { Sparkles, Lightbulb, Target } from "lucide-react";

export const ReportInsightPanel = ({ summary, insights = [], recommendations = [] }) => (
  <div data-testid="report-insight-panel" className="grid grid-cols-1 lg:grid-cols-3 gap-4">
    <div className="lg:col-span-3 rounded-xl border-l-4 border-amber-400 bg-amber-50/50 p-5">
      <div className="flex items-center gap-2 mb-2">
        <Sparkles className="w-4 h-4 text-amber-600" />
        <span className="text-[10px] uppercase tracking-wider font-semibold text-amber-800">
          Executive Summary
        </span>
      </div>
      <p className="text-sm text-slate-800 leading-relaxed whitespace-pre-wrap">
        {summary || "AI summary is not available for this report."}
      </p>
    </div>
    <div className="rounded-xl border border-slate-200 bg-white p-5">
      <div className="flex items-center gap-2 mb-3">
        <Lightbulb className="w-4 h-4 text-violet-600" />
        <span className="text-[10px] uppercase tracking-wider font-semibold text-slate-700">AI Insights</span>
      </div>
      {insights.length ? (
        <ul className="space-y-2.5">
          {insights.map((i, idx) => (
            <li key={idx} className="text-sm text-slate-700 leading-relaxed flex gap-2">
              <span className="text-violet-500 mt-0.5">•</span>
              <span>{i}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-xs text-slate-400">No insights generated.</p>
      )}
    </div>
    <div className="lg:col-span-2 rounded-xl border border-slate-200 bg-white p-5">
      <div className="flex items-center gap-2 mb-3">
        <Target className="w-4 h-4 text-emerald-600" />
        <span className="text-[10px] uppercase tracking-wider font-semibold text-slate-700">
          Recommended Actions
        </span>
      </div>
      {recommendations.length ? (
        <ul className="space-y-2.5">
          {recommendations.map((r, idx) => (
            <li key={idx} className="text-sm text-slate-700 leading-relaxed flex gap-3">
              <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100 text-emerald-700 text-[10px] font-bold flex-shrink-0">
                {idx + 1}
              </span>
              <span>{r}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-xs text-slate-400">No recommendations generated.</p>
      )}
    </div>
  </div>
);

export default ReportInsightPanel;
